import { AcceptedFiles } from '@insurancemenu/imenu-components-lib/dist/types/FileUpload';
import { makeAutoObservable } from 'mobx';

export default class FileUploadDelegate {
  private _uploadedFiles: AcceptedFiles = {};
  private _isFileUploadReset: boolean = false;

  public get uploadedFiles(): AcceptedFiles {
    return this._uploadedFiles;
  }

  public get uploadedFileNames(): string[] {
    return Object.keys(this._uploadedFiles);
  }

  public get isFileUploadReset(): boolean {
    return this._isFileUploadReset;
  }

  public get allFilesInOneFormat(): boolean {
    if (Object.keys(this._uploadedFiles).length < 1) {
      return true;
    }
    return [...new Set(Object.keys(this._uploadedFiles).map((name) => name.split('.').pop()))].length === 1;
  }

  public get noUploadedFiles(): boolean {
    return Object.keys(this._uploadedFiles).length === 0;
  }

  public setIsFileUploadReset(status: boolean): void {
    this._isFileUploadReset = status;
  }

  public setFiles(files: AcceptedFiles): void {
    this._uploadedFiles = files;
    if (Object.keys(files).length > 0) {
      this._isFileUploadReset = false;
    }
  }

  public resetFiles(): void {
    this._uploadedFiles = {};
    this._isFileUploadReset = true;
  }

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }
}
